import { useRef, useState } from "react";
import { cn } from "tailwind-variants";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { getAcceptString } from "common/artwork-file-types";
import { useDtfStore } from "./store";
import "./ReuploadBox.scss";

export default function ReuploadBox({ index, ...restProps }) {
  const store = useDtfStore();
  const fileRef = useRef(null);
  const [acceptedFileTypes] = useState(getAcceptString());

  function printAsIs() {
    return store.printAsIs;
  }

  function pdpType() {
    return store.pdpType;
  }

  function reuploadTitle() {
    if (printAsIs()) {
      return "Re-upload a gang sheet in the correct size";
    }
    return "Re-upload valid artwork";
  }

  function reuploadButton() {
    if (printAsIs()) {
      return "Re-upload a gang sheet";
    }
    return "Choose file";
  }

  function addFilesToQueue(...args) {
    return store.addFilesToQueue(...args);
  }

  function trackAddFileAreaClick() {
    submitDtfEvent("replace_artwork_file_clicked", {
      page: "pdp",
      pdp_type: pdpType()
    });
  }

  function uploadClick() {
    trackAddFileAreaClick();
    fileRef.current.click();
  }

  function handleFileChange(event) {
    const { files } = event.target;
    if (!files.length) return;
    addFilesToQueue({
      files,
      isDropEvent: false,
      artworkIndex: index
    });
    fileRef.current.value = "";
  }

  return (
    <div {...restProps} className={cn("reupload-box scope-0f997915", restProps.className)}>
      <input
        className="reupload-box__file scope-0f997915 hidden"
        ref={fileRef}
        type="file"
        accept={acceptedFileTypes}
        onChange={handleFileChange}
        data-testid="reupload-box-file"
      />

      <div className="reupload-box__title scope-0f997915">{reuploadTitle()}</div>
      <div
        className="reupload-box__upload-wrapper scope-0f997915"
        onClick={uploadClick}
        data-testid="reupload-box-upload-wrapper"
      >
        <span className="reupload-box__input-label scope-0f997915">{reuploadButton()}</span>
      </div>
    </div>
  );
}
